/* eslint-disable no-undef */

//@ts-ignore
import { noop } from '@mindtickle/utils';
import { getHighResolutionTime } from '../../../utils';
import { getExtendedLogger } from '../../Logger';
import logger from '../../../config/app.logger';
import { LOGGER_NAME } from '../config/constants';

const log = getExtendedLogger(LOGGER_NAME, logger);

export const loadRemoteModule = async (remote, module, remoteModuleLoadedCallback = noop) => {
  const startModuleLoadingTime = getHighResolutionTime();
  // Initializes the share scope. This fills it with known provided modules from this build and all remotes
  await __webpack_init_sharing__('default');

  const container = window[remote]; // or get the container somewhere else
  // Initializing a container more than once throws an error. Preventing container from initializing again and logging the error
  try {
    // Initialize the container, it may provide shared modules
    await container.init(__webpack_share_scopes__.default);
  } catch (error) {
    // Container was already initialized
    log(error);
  }
  const factory = await window[remote].get(module);
  const Module = factory();
  container.__dynamically_initialised__ = true;
  remoteModuleLoadedCallback(getHighResolutionTime() - startModuleLoadingTime);
  return Module;
};

export const isRemoteLoaded = remote => !!window[remote];

export const isRemoteIntialised = remote =>
  isRemoteLoaded(remote) && !!window[remote].__dynamically_initialised__;

export const getModuleFromInitalisedRemote = async (remote, module) => {
  const factory = await window[remote].get(module);
  return factory();
};

const TRACK_MAPPING = {
  stencil: 'integration',
  'stencil-int': 'integration',
  integration: 'integration',
  staging: 'staging',
  'stencil-stage': 'staging',
  prod: 'prod',
  'ux-refresh-prod': 'prod',
  'prod-us': 'prod-us',
  'ux-refresh-prod-us': 'prod-us',
  'ux-refresh-staging-ldr': 'staging',
  'ux-refresh-prod-ldr': 'prod',
  'ux-refresh-prod-us-ldr': 'prod-us',
};

export const getShellTrackValues = () => ({
  shellTrack: process.env.UI_SHELL_TRACK || '',
  track: TRACK_MAPPING[process.env.UI_SHELL_TRACK] || process.env.TRACK || '',
});
